export const AVAILABLE_PAGE_SIZE = [10, 25, 100];
export const DEFAULT_PAGE_SIZE = AVAILABLE_PAGE_SIZE[0];
export const DEFAULT_DROPDOWN_SIZE = 20;
